var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMsgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Z",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-10095.000000, -1329.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(10095.000000, 1329.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.991161 L0,11.8950903 C-0.000552240841,9.67002402 -0.00226783087,4.45933161 2.13936039,2.29373765 C4.40851413,-0.00109429456 7.66127282,-0.00052244509 11.7815482,0 L12.200724,0 C16.3198557,-0.00109429456 19.5737581,-0.00109429456 21.84234,2.29373765 C23.9593781,4.43531393 23.9828245,9.55393857 23.9822526,11.8196062 L24,11.8373335 L24,12.1049591 C24.0005522,14.3300254 24.0022678,19.5407178 21.8606396,21.7057399 C19.6292289,23.9628298 16.4456656,24 12.4237507,24 L12.2173081,24 L11.7998478,24 C7.68014431,23.9977126 4.42681376,24.0011437 2.15651629,21.7057399 C0.0148880694,19.5407178 0.00230707587,14.323735 0.00287893921,12.0986687 L0.00287893921,11.9202517",
    id: "Fill-1-Copy",
    fill: "#00CCAA"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "10.8181818 15.119403 7.95454545 12.2985075 7 13.238806 10.8181818 17 19 8.94029851 18.0454545 8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMsgSuccess);
export default __webpack_public_path__ + "static/media/ic-msg-success.b0cc8b30d7dc17717fad77d94f3706b2.svg";
export { ForwardRef as ReactComponent };